import { DefinirAutorizadoSelecionado } from "app/types/Autorizado";
import React from "react";

const estiloAutorizadoPesquisar = require("./autorizado-pesquisar.module.scss").default;

export type AutorizadoPesquisarProps = {
    dadosDefinirAutorizado: DefinirAutorizadoSelecionado
}

export const AutorizadoPesquisar = (props: AutorizadoPesquisarProps) => {

    return (
        <>
            <div className={`_mt-2 ${estiloAutorizadoPesquisar.form}`}>
                <label>Nome</label>
                <div>{props.dadosDefinirAutorizado?.Autorizado?.Nome}</div>
                <label>Observação</label>
                <textarea rows={3} maxLength={254} disabled>{props.dadosDefinirAutorizado?.Autorizado?.Observacao}</textarea>
            </div>
        </>
    );
}
